import { useUser } from '@clerk/clerk-react';
import { useState, useEffect } from 'react';
import { UsersAPI } from '../../api';

export function useAdmin() {
  const { user, isLoaded } = useUser();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function checkAdminStatus() {
      if (!isLoaded) return;

      if (!user) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      // Superadmin fallback: owner always has access even if DB is unreachable
      const email = user.primaryEmailAddress?.emailAddress || '';
      if (email.toLowerCase() === 'adrweb@gmail.com') {
        setIsAdmin(true);
        setLoading(false);
        return;
      }

      try {
        const response = await UsersAPI.getByClerkId(user.id);
        if (response.success && response.data) {
          setIsAdmin(!!response.data.isAdmin);
        } else {
          setIsAdmin(false);
        }
      } catch (error) {
        console.error('Error checking admin status:', error);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    }

    checkAdminStatus();
  }, [user, isLoaded]);

  return { isAdmin, loading };
}
